import React, { useState, useEffect } from 'react'
import ContactRadioGroup, { ContactSelectType } from '../ContactRadioGroup'
import { ContactAddIcon, ContactSubIcon } from '../../conf/images'
import './index.css'
import {
    getReplyObjects,
    ObjectType,
    ContactObject,
    getBotReplySettings,
    BotReplySettings,
    updateBoReplySettings,
} from '../../service/api/bot'
import { useHistory } from 'react-router'
import { ContactsPage } from '../../conf/routePath'
import ContactItem from '../ContactItem'
import { useIonViewDidEnter } from '@ionic/react'
import { useDispatch } from 'react-redux'
import { setBotSetting } from '../../redux/actions/bot'

interface ContactSelectorProps {
    title?: string
    className?: string
    contactType?: ObjectType
}

interface OptionButtonProps {
    type: 'add' | 'sub'
    onSelect?: () => void
}
const OptionButton: React.FC<OptionButtonProps> = (props) => {
    const { type } = props
    return (
        <span className='contact-option option-item' onClick={props.onSelect}>
            {type === 'add' && (
                <img className='option-icon' src={ContactAddIcon} alt='icon' />
            )}
            {type === 'sub' && (
                <img className='option-icon' src={ContactSubIcon} alt='icon' />
            )}
        </span>
    )
}
const ContactSelector: React.FC<ContactSelectorProps> = (props) => {
    const { contactType = 'GROUP' } = props
    const history = useHistory()
    const [selectType, setSelectType] = useState<ContactSelectType | null>(null)
    const [replyObjects, setReplyObjects] = useState<ContactObject[]>([])
    const [botReplySettings, setBotReplySettings] = useState<BotReplySettings>(
        {}
    )
    useIonViewDidEnter(() => {
        loadReplyBotSettings()
        loadReplyObjects()
    })
    useEffect(() => {
        if (botReplySettings) {
            // console.log(botReplySettings)
            if (contactType === 'GROUP') {
                switch (botReplySettings.group_reply_object_type) {
                    case 'GROUP_ALL':
                        setSelectType('all')
                        break
                    case 'GROUP_LIST':
                        setSelectType('appoint')
                        break
                    case 'NO_GROUP': {
                        setSelectType(null)
                    }
                }
            }
            if (contactType === 'FRIEND') {
                switch (botReplySettings.friend_reply_object_type) {
                    case 'FRIEND_ALL':
                        setSelectType('all')
                        break
                    case 'FRIEND_LIST':
                        setSelectType('appoint')
                        break
                    case 'NO_FRIEND': {
                        setSelectType(null)
                    }
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [botReplySettings])

    const loadReplyObjects = async () => {
        try {
            let res = await getReplyObjects(contactType)
            // console.log(res)
            setReplyObjects(res.wechaty_reply_object_list)
        } catch (error) {}
    }

    const dispatch = useDispatch()
    const loadReplyBotSettings = async () => {
        try {
            // console.log('我要请求接口了。。。。。。')
            let res = await getBotReplySettings()
            setBotReplySettings(res)
            // console.log('12343434', res)
            dispatch(setBotSetting(res))
        } catch (error) {
            console.error(error)
        }
    }
    const onGroupTypeChange = async (objType: ContactSelectType | null) => {
        if (contactType === 'FRIEND') {
            switch (objType) {
                case 'all':
                    await updateBoReplySettings({
                        friend_reply_object_type: 'FRIEND_ALL',
                    })
                    break
                case 'appoint':
                    await updateBoReplySettings({
                        friend_reply_object_type: 'FRIEND_LIST',
                    })
                    break
                case null:
                    await updateBoReplySettings({
                        friend_reply_object_type: 'NO_FRIEND',
                    })
                    break
            }
        }
        if (contactType === 'GROUP') {
            switch (objType) {
                case 'all':
                    await updateBoReplySettings({
                        group_reply_object_type: 'GROUP_ALL',
                    })
                    break
                case 'appoint':
                    await updateBoReplySettings({
                        group_reply_object_type: 'GROUP_LIST',
                    })
                    break
                case null:
                    await updateBoReplySettings({
                        group_reply_object_type: 'NO_GROUP',
                    })
                    break
            }
        }
    }
    return (
        <div className={`contact-selector ${props.className || ''}`}>
            {contactType === 'GROUP' && (
                <ContactRadioGroup
                    title='群'
                    allLabel='全部群'
                    appointLabel='指定群'
                    selectType={selectType}
                    onSelect={(type) => {
                        console.log(type)
                        onGroupTypeChange(type)
                        setSelectType(type)
                    }}
                />
            )}
            {contactType === 'FRIEND' && (
                <ContactRadioGroup
                    title='好友'
                    allLabel='全部好友'
                    appointLabel='指定好友'
                    selectType={selectType}
                    onSelect={(type) => {
                        onGroupTypeChange(type)
                        setSelectType(type)
                    }}
                />
            )}
            <div className='contact-list'>
                {selectType === 'appoint' &&
                    replyObjects.map((item) => (
                        <ContactItem
                            className='contact-object-item'
                            key={item.uid}
                            nickname={item.name}
                            avatar={item.head_url}
                        />
                    ))}
                {selectType === 'appoint' && (
                    <OptionButton
                        type='add'
                        onSelect={() => {
                            history.push(ContactsPage, {
                                type: contactType,
                                option: 'add',
                            })
                        }}
                    />
                )}
                {replyObjects.length > 0 && selectType === 'appoint' && (
                    <OptionButton
                        type='sub'
                        onSelect={() => {
                            history.push(ContactsPage, {
                                type: contactType,
                                option: 'sub',
                            })
                        }}
                    />
                )}
            </div>
        </div>
    )
}

export default ContactSelector
